import React, { useEffect, useState } from 'react';

import Header from '../components/Header';
import Button from '../components/Button';

const GOOGLE_SHEET_API = 'https://script.google.com/macros/s/AKfycbz6RnSEKEjiBoaDmMYQ1Gd5xE7icdEqz6bqvM90YMGKKOvzmHTIjZwVJMZq4yfsBLpUVQ/exec';

export default function VerifyCertificate() {
  const [records, setRecords] = useState([]);      // all rows from the sheet
  const [certificateId, setCertificateId] = useState('');
  const [result, setResult] = useState(null);      // the row that matches
  const [error, setError] = useState('');

  // fetch the sheet once when the component mounts
  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(GOOGLE_SHEET_API);
        const json = await res.json();
        setRecords(json);              // save the whole table
      } catch (err) {
        setError('Could not load certificate list.');
        console.error(err);
      }
    }
    load();
  }, []);

  // handler for the form
  const handleSubmit = e => {
    e.preventDefault();
    const match = records.find(r => String(r.CertificateId).trim() === certificateId.trim());
    if (match) {
      setResult(match);
      setError('');
    } else {
      setResult(null);
      setError('Certificate ID not found.');
    }
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100vw',
        minHeight: '100vh',
        backgroundColor: '#000000',
      }}
    >
      <Header/>
      <div style={{
        position: 'relative',
        top: "5rem",
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2,
        fontFamily: '"Inter", system-ui, sans-serif',
        color: '#ffffff',
        padding: '0 20px',
        boxSizing: 'border-box',
        textAlign: 'center',
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          gap: '1rem', 
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            color: '#ffffff',
            textTransform: 'uppercase',
            letterSpacing: '0.1rem',
            marginBottom: '0.5rem',
          }}>
            Verify Certificate
          </h1>
          <div style={{
            display: 'flex',
            gap: '1rem',
            flexWrap: 'wrap',
            justifyContent: 'center',
            maxWidth: '1200px',
            margin: '0 auto',
          }}>
            <div style={{
              background: 'rgba(99, 102, 241, 0.1)',
              padding: '2rem',
              borderRadius: '1rem',
              flex: '1',
              minWidth: '300px',
              maxWidth: '500px',
              backdropFilter: 'blur(10px)', // For most browsers
              WebkitBackdropFilter: 'blur(10px)', // For Safari on iOS
              border: '1px solid rgba(99, 102, 241, 0.2)',
            }}>
              <form onSubmit={handleSubmit} style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '1rem',
                width: '100%',
              }}>
                <label style={{ 
                color: '#ffffff',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                width: '80%',
                margin: '0 auto',
                textAlign: 'left',
              }}>Certificate ID:
                  <input
                    value={certificateId}
                    onChange={e => setCertificateId(e.target.value.replace(/\s+/g, ''))}
                    placeholder="Certificate ID"
                    required
                    onKeyDown={(e) => {
                      // Prevent the user from pressing the spacebar
                      if (e.key === ' ') e.preventDefault();
                    }}
                    style={{
                      fontSize: '1rem',
                      width: 'calc(100% - 1rem - 2px)',
                      padding: '0.5rem',
                      marginTop: '0.5rem',
                      borderRadius: '5px',
                      border: '1px solid #ccc',
                    }}
                  />
                </label>
                <Button type="Submit" label="Verify" style={{width: '90%'}} />
              </form>

              {error && <p style={{ color: 'crimson' }}>{error}</p>}

              {result && (
                <div style={{ marginTop: 24, padding: 16, textAlign: "left", border: '1px solid #ccc', borderRadius: 6 }}>
                  <h2>Certificate Details</h2>
                  <p><strong>ID :</strong> {result.CertificateId}</p>
                  <p><strong>Name :</strong> {result.Name}</p>
                  <p><strong>Title :</strong> {result.Title}</p>
                  <p><strong>Completion Date :</strong> {result.CompletionDate}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}